import * as React from 'react';
import { injectIntl, FormattedMessage, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { Button, Dropdown } from 'semantic-ui-react';

import { localeData } from '../../locales/data';
import FlashMessages from '../FlashMessages/FlashMessages';

import { AlphasAddToListPropsMain } from './types';

type AlphasAddToListPropsGeneric = AlphasAddToListPropsMain & InjectedIntlProps;

type AlphasAddToListIntlState = {
  list: any;
  newLists: any;
  isNewList: boolean;
};

class AlphasAddToListIntl extends React.Component<AlphasAddToListPropsGeneric, AlphasAddToListIntlState> {
  constructor(props: AlphasAddToListPropsGeneric) {
    super(props);

    this.state = {
      list: this.userListToDropdown(this.props.userLists ? this.props.userLists.toJS() : []),
      newLists: [],
      isNewList: false,
    };
  }

  componentDidMount() {
    if (this.props.userLists) {
      this.setState({
        list: this.userListToDropdown(this.props.userLists.toJS()),
      });
    }
  }

  componentDidUpdate(prevPros: AlphasAddToListPropsGeneric) {
    if (this.props.userLists && prevPros.userLists.size !== this.props.userLists.size) {
      this.setState({
        list: this.userListToDropdown(this.props.userLists.toJS()),
      });
    }
  }

  userListToDropdown = (list: any[]) =>
    list.map((val: any) => ({
      text: val.name,
      value: val.name,
    }));

  handleOnAddNewList = (_: any, data: any) => {
    this.setState({
      list: [...this.state.list, { text: data.value, value: data.value }],
      newLists: [...this.state.newLists, data.value],
      isNewList: true,
    });
    this.props.handleChange(_, data);
  };

  handleDropdownChange = (e: any, data: any) => {
    if (this.state.newLists.indexOf(data.value) === -1) {
      this.setState({
        isNewList: false,
      });
    } else {
      this.setState({
        isNewList: true,
      });
    }
    this.props.handleChange(e, data);
  };

  render() {
    const { list, fetching, rowAlpha, intl, handleAddToList } = this.props;

    const handleAddToNewList = () => handleAddToList(list, true, false, rowAlpha);
    const handleAddToOldList = () => handleAddToList(list, false, false, rowAlpha);
    const handleAddToNewListAndView = () => handleAddToList(list, true, true, rowAlpha);
    const handleAddToOldListAndView = () => handleAddToList(list, false, true, rowAlpha);

    return (
      <div className="alphaAdd">
        <div className="alphaAdd__title">
          <FormattedMessage
            tagName="span"
            id="alphasAddToList.addAlphaToAList"
            defaultMessage={localeData.en['alphasAddToList.addAlphaToAList']}
          />
        </div>
        <div className="alphaAdd__content">
          <div className="alphaAdd__content-description">
            <FormattedMessage
              tagName="span"
              id="alphasAddToList.description"
              defaultMessage={localeData.en['alphasAddToList.description']}
            />
          </div>
          <div className="alphaAdd__content-item">
            <Dropdown
              placeholder={intl.formatMessage({
                id: 'alphasAddtoList.placeHolderListName',
                defaultMessage: localeData.en['alphasAddtoList.placeHolderListName'],
              })}
              options={this.state.list}
              className="alphaAdd__content-dropdown dropdown-custom"
              value={list}
              onChange={this.handleDropdownChange}
              name="list"
              disabled={fetching}
              searchInput={{ id: 'listName' }}
              search={true}
              allowAdditions={true}
              onAddItem={this.handleOnAddNewList}
              selection={true}
            />
            <div className="alphaAdd__content-item__buttons">
              <Button
                className="alphaAdd__content-button"
                primary={true}
                onClick={this.state.isNewList ? handleAddToNewList : handleAddToOldList}
                disabled={list === '' || fetching}
              >
                {this.state.isNewList ? (
                  <FormattedMessage
                    tagName="span"
                    id="alphasAddToList.AddAlphaToNewList"
                    defaultMessage={localeData.en['alphasAddToList.AddAlphaToNewList']}
                  />
                ) : (
                  <FormattedMessage
                    tagName="span"
                    id="alphasAddToList.addAlphaToList"
                    defaultMessage={localeData.en['alphasAddToList.addAlphaToList']}
                  />
                )}
              </Button>
              <Button
                className="alphaAdd__content-button"
                primary={true}
                onClick={this.state.isNewList ? handleAddToNewListAndView : handleAddToOldListAndView}
                disabled={list === '' || fetching}
              >
                {this.state.isNewList ? (
                  <FormattedMessage
                    tagName="span"
                    id="alphasAddToList.AddAlphaToNewListAndViewList"
                    defaultMessage={localeData.en['alphasAddToList.AddAlphaToNewListAndViewList']}
                  />
                ) : (
                  <FormattedMessage
                    tagName="span"
                    id="alphasAddToList.addAlphaToListAndViewList"
                    defaultMessage={localeData.en['alphasAddToList.addAlphaToListAndViewList']}
                  />
                )}
              </Button>
            </div>
          </div>
        </div>
        <div className="alphaAdd__message">
          <FlashMessages location="alpha-list" />
        </div>
      </div>
    );
  }
}

export const AlphasAddToListMain = injectIntl(AlphasAddToListIntl);
